import { observer } from 'mobx-react-lite';
import { AttachmentIconViewBase, IconSize } from 'owa-attachment-common-view';
import { AttachmentModel, TypeOfAttachment } from 'owa-attachment-model-store';
import { AttachmentClass } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import ItemAttachment from 'owa-service/lib/contract/ItemAttachment';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import * as React from 'react';

const ITEM_CLASS_NOTE = 'IPM.Note';

export interface AttachmentIconProps {
    attachmentId: AttachmentId;
    className?: string;
    useCloudIcon?: boolean;
    iconSize?: IconSize;
}

// This component is responsible for showing the attachment icon view.
const AttachmentIconView = observer(function AttachmentIconView(props: AttachmentIconProps) {
    const attachment: AttachmentModel = getAttachment(props.attachmentId);
    const isCloudy: boolean = attachment.type === TypeOfAttachment.Reference;
    let isFolder: boolean = isCloudy
        ? (attachment.model as ReferenceAttachment).AttachmentIsFolder
        : false;

    let embeddedItemClass: string | null = null;
    if (!isCloudy && attachment.type === TypeOfAttachment.Mail) {
        embeddedItemClass =
            (attachment.model as ItemAttachment).EmbeddedItemClass || ITEM_CLASS_NOTE;
    }

    return (
        <AttachmentIconViewBase
            contentType={attachment.model.ContentType}
            customizeStyle={props.className}
            embeddedItemClass={embeddedItemClass}
            fileName={attachment.model.Name}
            iconSize={props.iconSize}
            isBlocked={attachment.attachmentClass === AttachmentClass.Blocked}
            isCloudy={isCloudy}
            isFolder={isFolder}
            useCloudIcon={props.useCloudIcon}
        />
    );
});
export default AttachmentIconView;
